import { gql, TypedDocumentNode } from "@apollo/client";

import {
  ExecuteScenarioMutation,
  ExecuteScenarioMutationVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { getCaseByIdQuery } from "src/graphql/anti-fraud/queries/cases/GetCaseByIdQuery.ts";
import { usePerformMutation } from "src/graphql/utils";

export const executeScenarioMutation = gql(/* GraphQL */ `
  mutation ExecuteScenario($scenarioId: ID!, $caseId: ID!) {
    executeScenario(input: { scenarioId: $scenarioId, caseId: $caseId }) {
      scenarioExecutionResult {
        id
        globalScore
        scenarioVersion {
          id
        }
      }
      status
    }
  }
`) as TypedDocumentNode<ExecuteScenarioMutation, ExecuteScenarioMutationVariables>;

export const useExecuteScenarioMutation = ({ onSuccess }: { onSuccess? }) => {
  return usePerformMutation(executeScenarioMutation, {
    onSuccess,
    mutationOption: {
      refetchQueries: [getCaseByIdQuery],
      awaitRefetchQueries: true,
    },
  });
};
